export default "__VITE_ASSET__CA56bCtj__"